<div
  class="mt-2 pt-2 border-t border-solid border-surface-200 dark:border-surface-700 flex flex-row flex-wrap items-center gap-x-3.5 gap-y-1"
  data-e2e="ai-stats-row"
>
  @if (stats().latencyMs !== undefined) {
    <span class="text-[11px] text-surface-600 dark:text-surface-300" data-e2e="ai-stats-latency">
      {{ 'cl_chat.aiStatsLatency' | translate }}
      <span class="font-bold text-surface-950 dark:text-surface-0">{{
        'cl_chat.aiStatsLatencyValue' | translate: { ms: stats().latencyMs }
      }}</span>
    </span>
  }
  @if (stats().totalTokens !== undefined) {
    <span class="text-[11px] text-surface-600 dark:text-surface-300" data-e2e="ai-stats-tokens">
      {{ 'cl_chat.aiStatsTokens' | translate }}
      <span class="font-bold text-surface-950 dark:text-surface-0">{{ stats().totalTokens }}</span>
    </span>
  }
  @if (stats().retrievedChunks !== undefined) {
    <span class="text-[11px] text-surface-600 dark:text-surface-300" data-e2e="ai-stats-retrieved">
      {{ 'cl_chat.aiStatsRetrieved' | translate }}
      <span class="font-bold text-surface-950 dark:text-surface-0">{{
        'cl_chat.aiStatsRetrievedValue' | translate: { count: stats().retrievedChunks }
      }}</span>
    </span>
  }
  @if (modeLabelKey()) {
    <span class="text-[11px] text-surface-600 dark:text-surface-300" data-e2e="ai-stats-mode">
      {{ 'cl_chat.aiStatsMode' | translate }}
      <span class="font-bold text-surface-950 dark:text-surface-0">{{ modeLabelKey() | translate }}</span>
    </span>
  }
</div>
